export default {
  zh: {
    enjoy: '注册免费试用3天',
    domesticServers: '国内线路',
    foreignServers: '国外线路',
    moreDomesticServers: '更多国内专线',
    moreForeignServers: '更多国外专线',
    vipAdvantage: 'VIP 可享受稳定快速线路，手机、平板、电脑跨平台使用！',
    numberOfDevices: '设备数：',
    device: '台',
    salePrice: '折后总价',
    month: '月',
    year: '一年',
    threeMonths: '季',
    sixMonths: '半年',
    noLimit: '无限流量',
    infoEncryption: '信息加密',
    topUp: '充值',
    subscribe: '连续订阅',
    CNY: '￥',
    USD: '$',
    serviceUpgrade: '服务升级',
    instructions: '升级你的服务套餐，增加设备，降低资费。更高效便捷的加速器体验。',
    deviceNum: '设备数量：',
    deviceUnit: '台',
    serviceTime: '服务时长：',
    automaticRenewal: '自动续费',
    day: '天',
    week: '周',
    everyMonth: '月',
    subtotal: '小 计：',
    upgradeFee: '含余量升级费：',
    buyNow: '连续订阅',
    declaration: '订阅声明：',
    declarationList: [
      "可随时取消连续订阅服务，取消后不再自动续费。",
      "连续订阅服务暂只支持 PayPal、信用卡支付方式。",
    ],
    upgradeTo: "可升级到",
    devices: "台",
    off_text: "活动特惠，免费赠送 | 个月 | 个月",
    off_text_day: "活动特惠，免费赠送 | 天 | 天",
    new_off_text: "赠送 | 个月 | 个月",
    new_off_text_day: "赠送 | 天 | 天",
    guarantee: "7天退款保障",
    intro_1: "7天退款保障",
    intro_2: "台 | 台",
    intro_3: "在线",
    expiration: "倒计时",
    bestDeal: "双11特惠",
    getNow: "立即获取",
    cancelSubscriptionTitle: "检测到您已存在订阅，请先取消订阅",
    paymentMethod: "支付方式：",
    subscriptionPackage: "订阅套餐：",
    back: "返 回",
    cancelSubscription: "取消订阅",
    itunesTip: "请前往 App Store 取消订阅",
    googleTip: "请前往 Google Play 商店 取消订阅",
  },
  en: {
    enjoy: "Enjoy 3 days free trial after register",
    domesticServers: "Domestic Servers",
    foreignServers: "Foreign Servers",
    moreDomesticServers: "More Domestic Servers",
    moreForeignServers: "More Foreign Servers",
    vipAdvantage:
      "VIP can enjoy stable and high speed servers on mobile phone, tablet and PC!",
    numberOfDevices: "Number of Devices: ",
    device: "Device",
    salePrice: "Sale Price",
    month: "Month",
    year: "Year",
    threeMonths: "3 Months",
    sixMonths: "6 Months",
    noLimit: "Unlimited Traffic",
    infoEncryption: "Information Encryption",
    topUp: "Get Now",
    subscribe: "Subscribe",
    CNY: "￥",
    USD: "$",
    test: "Subscription Declaration",
    serviceUpgrade: "Service Upgrade",
    instructions:
      "Upgrade your service package, increase more devices and deduct average cost. Enjoy higher speed and more convenient VPN experience.",
    deviceNum: "Number of Devices:",
    serviceTime: "The service time:",
    deviceUnit: "Device | Devices",
    automaticRenewal: "Automatic renewal",
    day: "day | days",
    week: "week | weeks",
    everyMonth: "mo.",
    subtotal: "Subtotal:",
    upgradeFee: "Allowance upgrade fee:",
    buyNow: "Subscribe",
    declaration: "Subscription Declaration：",
    declarationList: [
      'Recurring subscription service can be canceled at any time, and will not renew automatically once you have canceled it.',
      'The recurring subscription service only supports PayPal and Credit Card payment methods.'
    ],
    upgradeTo: 'Upgrade to ',
    devices: ' device | devices',
    off_text: "get extra | month free | months free",
    off_text_day: "get extra | day free | days free",
    new_off_text: "+ | MONTH FREE | MONTHS FREE",
    new_off_text_day: "+ | day free | days free",
    guarantee: '7-day money-back guarantee',
    intro_1: '7-day refund guarantee',
    intro_2: 'device | devices',
    intro_3: 'online',
    expiration: 'Expires in',
    bestDeal: '11.11 BIG SALE',
    getNow: "Get Now",
    cancelSubscriptionTitle: "You already have an active subscription, please cancel the current subscription first",
    paymentMethod: "Payment Method: ",
    subscriptionPackage: "Subscription Plan: ",
    back: "Back",
    cancelSubscription: "Unsubscribe",
    itunesTip: "Please cancel your subscription on the App Store",
    googleTip: "Please cancel your subscription on Google Play",
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/choosePackage/lang.js